import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Button } from '@fluentui/react-northstar';
import styles from './DeprecationNotice.module.scss';

interface IDeprecationNoticeProps extends WithTranslation, RouteComponentProps { }

interface IDeprecationNoticeState {
    hidden: boolean,
}

class DeprecationNotice extends React.Component<IDeprecationNoticeProps> {

  public state: IDeprecationNoticeState = {
    hidden: window.sessionStorage.getItem('deprecationNotice') === 'hidden'
}

  public onClose = () => {
    window.sessionStorage.setItem('deprecationNotice', 'hidden');
    this.setState({ hidden: true });
  }

  render() {
    if(this.state.hidden) {
      return null;
    }
    return (
      <div className={styles.DeprecationNotice}>
        <div className={styles.DeprecationNoticeContent}>
          <h1>{this.props.t('deprecation.headline')}</h1>
          <div dangerouslySetInnerHTML={{ __html: this.props.t('deprecation.content') }} />
          <Button primary fluid content={this.props.t('deprecation.button')} onClick={this.onClose} />
        </div>
      </div>
    );
  }

}

export default withTranslation()(withRouter(DeprecationNotice));